export const formatNumber = (num: number | string, fractionalDigits: number = 0, locale = "en-US") => {
  const parsed = typeof num === "string" ? Number(num) : num;

  if (isNaN(parsed)) return "0";

  return parsed?.toLocaleString(locale, {
    maximumFractionDigits: fractionalDigits,
  });
};

/**
 * Formats a whole number into a compact string representation (e.g., 4506 → "4K", 1457987 → "1M")
 * @param num The number to format
 */
export const formatNumberCompact = (num: number): string => {
  if (num < 1000) return num.toString();
  if (num < 1000000) {
    const thousands = Math.floor(num / 1000);
    return `${thousands}K`;
  }
  const millions = Math.floor(num / 1000000);
  return `${millions}M`;
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + " " + sizes[i];
};

export function isUrl(text: string): boolean {
  try {
    new URL(text);
    return true;
  } catch {
    return false;
  }
}

export const formatFundingAmount = (amount: number | null | string, fractionalDigits: number = 0) => {
  if (amount === null) return "TBD";
  return formatNumber(amount, fractionalDigits);
};

const formatDetail = (val: string | number) => {
  if (typeof val === "number") return val.toString();

  if (val === "yes") return "Yes";
  if (val === "no") return "No";

  return val;
};

export default formatDetail;
